import { Backend } from '@/_axios';

export default {
  predict(data) {
    return Backend.post('/sam_service/predict', data);
  },
};
